export const AMAZON_ASIN_URL = "https://www.amazon.com/dp";

/**
 * AUT-496: a keyword's Amazon search results page.
 *
 * `amazon.com` is hardcoded because Signal supports the US marketplace only. It is written once,
 * here, so adding a marketplace is a change to this function rather than to every keyword table.
 * `encodeURIComponent` rather than a template literal: a keyword may carry spaces, `&`, an
 * apostrophe or non-ASCII characters, and all of them have to survive the query string.
 */
export function amazonSearchUrl(keyword: string): string {
  return `https://www.amazon.com/s?k=${encodeURIComponent(keyword)}`;
}
